(function ( $ ) {

	$.fn.accordions = function () {
		var $elem = $( this ),
			parent = $elem.parent(),
			$accordions = $elem.find( '.accordion__item' ),
			$accordionTitles = $accordions.find( '.accordion__title' ),
			$accordionsInner,
			$accordionContents = $accordions.find( '.accordion__content' ),
			slideOpenSpeed = 1000,
			slideCloseSpeed = 350;

		var init = function () {

				$accordionsInner = $accordionContents.wrapInner('<div class="accordion__content__inner" />').children();
				$accordionsInner.hide();

				ariaSetup();
				bindEvents();
			},
			ariaSetup = function () {

				$accordions.each( function ( i, el ) {
					var $this = $( this ),
						id = 'collapsible-' + i,
						$title = $this.find( '.accordion__title' ),
						$content = $this.find( '.accordion__content' );


					$title
						.attr( {
							'aria-expanded' : false,
							'aria-controls' : id
						} );

					$content
						.attr( {
							'aria-hidden' : 'true'
						} )
						.attr( 'id', id );

				} );

			},
			bindEvents = function () {
				$accordions.on( 'click', function ( e ) {
					toggleAccordion( $( this ) );
				} );
			},
			toggleAccordion = function ( $accordion ) {

				var $accordionsToProcess,
					isOpeningNew = !$accordion.hasClass( 'open' );

				if ( isOpeningNew ) {
					// opening new and closing others
					$accordionsToProcess = $accordions.not( $accordion );


					var $title = $accordion.find( '.accordion__title' ),
						$content = $accordion.find( '.accordion__content' ).find('.accordion__content__inner');

					$content.slideDown();
					$accordion.addClass( 'open' );

					$title.attr( {
						'aria-expanded' : true,
					} );
					$content.attr( {
						'aria-hidden' : false
					} );

				} else {
					// closing open
					$accordionsToProcess = $accordions;
				}


				$accordionsToProcess.each( function ( i, el ) {
					var $this = $( this ),
						$title = $this.find( '.accordion__title' ),
						$content = $this.find( '.accordion__content' ).find('.accordion__content__inner');

					$title.attr( {
						'aria-expanded' : false,
					} );

					$content.attr( {
						'aria-hidden' : 'true'
					} );

					$this.removeClass( 'open' );
					$content.slideUp( 'fast' );

				} );


			};


		init();
		return this;
	};

}( jQuery ));
